import Caption from 'components/Luxkit/Typography/Caption'
import Heading from 'components/Luxkit/Typography/Heading'
import Group from 'components/utils/Group'
import React from 'react'
import styled from 'styled-components'
import LePackageUpgradePrice from './LePackageUpgradePrice'
import FormatCurrency from 'components/Common/FormatCurrency'
import PriceRowCaption from 'components/Luxkit/PricePoints/PriceRowCaption'
import { usePackageUpgradePrice } from 'hooks/OfferPage/usePackageUpgradePrice'
import { pluralizeToString } from 'lib/string/pluralize'
import { VIRGIN_VELOCITY_BURN_RATE } from 'constants/partnerships'
import { commaSeparatedNumber } from 'lib/format/formatNumber'
import VelocityIcon from 'components/Common/Vendors/Partnership/PartnershipIcons/VelocityIcon'
import { rem } from 'polished'
import { mediaQueryOnly } from 'components/utils/breakpoint'

const IconWrapper = styled.div`
  margin-left: ${rem(8)};
`

const PriceAndPointsDivider = styled.div`
  ${mediaQueryOnly.mobile} {
    padding: ${rem(8)} 0;
  }
`

const StyledGroup = styled(Group)`
  max-width: ${rem(400)};
`

interface Props {
  packageUpgrade: App.PackageOptionView
  hasFlightsSelected?: boolean
}

function LePackageUpgradeWithVelocityPoints({ packageUpgrade, hasFlightsSelected }: Props) {
  const { total, duration, price: upgradePrice } = usePackageUpgradePrice(packageUpgrade, hasFlightsSelected)
  const velocityPoints = Math.floor(upgradePrice / VIRGIN_VELOCITY_BURN_RATE)

  return (
    <div>
      <StyledGroup direction="vertical" tabletDirection="horizontal" verticalAlign="space-between" tabletVerticalAlign="center" horizontalAlign="space-between">
        <LePackageUpgradePrice
            packageUpgrade={packageUpgrade}
            hasFlightsSelected={hasFlightsSelected}
          />
        <PriceAndPointsDivider>
          <Caption variant="large" colour="neutral-three">
            OR
          </Caption>
        </PriceAndPointsDivider>
        <div>
          <Group direction="horizontal" verticalAlign="center">
            <Heading as="span" variant="heading6">
              +{commaSeparatedNumber(velocityPoints)} Velocity Points
            </Heading>
            <IconWrapper>
              <VelocityIcon width={20} height={20} />
            </IconWrapper>
          </Group>
          <PriceRowCaption>
            <FormatCurrency value={total}/> total for {pluralizeToString('night', duration)}
          </PriceRowCaption>
        </div>
      </StyledGroup>
    </div>
  )
}

export default LePackageUpgradeWithVelocityPoints
